var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCheckedBlueLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0971 14.8174L16.6635 7.26726C16.8184 7.08909 17.0025 7 17.2155 7C17.4286 7 17.6126 7.08909 17.7676 7.26726C17.9225 7.44543 18 7.65702 18 7.902C18 8.14699 17.9225 8.35857 17.7676 8.53675L10.6395 16.7327C10.4845 16.9109 10.3037 17 10.0971 17C9.8905 17 9.70971 16.9109 9.55475 16.7327L6.22314 12.902C6.06818 12.7238 5.99393 12.5122 6.00039 12.2673C6.00684 12.0223 6.08755 11.8107 6.24251 11.6325C6.39747 11.4543 6.58148 11.3653 6.79455 11.3653C7.00762 11.3653 7.19163 11.4543 7.34659 11.6325L10.0971 14.8174Z",
    fill: "#006BD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCheckedBlueLine);
export default __webpack_public_path__ + "static/media/check_checked_blue_line.0d2acb6006c2043b552739d79edc9948.svg";
export { ForwardRef as ReactComponent };